import _ from 'lodash';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import SphUtils from 'sg-sph-utils';
import {
    ADOBE_TOPICS,
    SgSptTripUtils,
    SgSubmissionUtil,
    SgDateUtil,
    SgProductService
} from 'saga-modules';
import { publish } from '@jutro/events';
import { sanitizeUrl } from '@jutro/platform';
import SgSptConstants from 'sg-spt-constants';
import SgSmiCookieUtils from 'sg-smi-cookie-utils';
import SgSmiUtils from 'sg-smi-utils';
import SpmUtils from 'sg-spm-utils';
import SphConstants from 'sg-sph-constants';
import SmiConstants from 'sg-smi-constants';
import SPTTaggingProperties from 'sg-adobe-analytics/SPT/SPTTaggingProperties';
import SpmConstants from 'sg-spm-constants';
import htmlParser from 'html-react-parser';
import sanitizeHtml from 'sanitize-html-react';
import CommonConstants from 'sg-common-constants';
import moment from 'moment';
import messages from './SgQnBLobSpecificUtil.messages';

function getPaymentsHeaderMessage(modelVM) {
    const { isHome, isSmi } = appConfig;
    const isTailormade = isHome ? SphUtils.isHomeTailormade(modelVM) : false;
    const isLandlord = isHome ? SphUtils.isLandlord(modelVM) : false;
    const offerZeroDdInterest = _.get(modelVM, 'quoteData.offeredQuotes.value[0].offerZeroDDInterest', false);
    if (!offerZeroDdInterest && !isLandlord && !isTailormade && !isSmi) {
        return messages.InstallmentInformationWithApr;
    }
    if ((offerZeroDdInterest || isLandlord) && !isTailormade && !isSmi) {
        return messages.InstallmentInformationNoApr;
    }
    if (isTailormade || isSmi) {
        return messages.InstallmentInformationAprAbsent;
    }
    return '';
}
function getSupportBannerMessage() {
    const { isHome, isMotor, isSmi } = appConfig;
    const confirmationSupportBanner = {
        hasBanner: !!(isMotor || isHome || isSmi),
        bannerContent: messages.SupportBannerMessage,
        bannerLink: messages.SupportServicesLink
    };
    return confirmationSupportBanner;
}

function getPaymentsHeaderMessageParameters(chosenPlan) {
    return {
        installments: chosenPlan.numberOfInstallments_Ext > 1 ? chosenPlan.numberOfInstallments_Ext.toString() : '',
        apr: chosenPlan.apr_Ext ? chosenPlan.apr_Ext.toString() : ''
    };
}

function getRetrievalPageErrorReasonMessage(errorReasonCode) {
    switch (errorReasonCode) {
        case SphConstants.SG_HOME_ERROR_REASONS.NO_LANDLORD_TENANCY_AGREEMENT_OVER_6_MONTHS:
            return messages.RetrievalPageTenancyAgreementDecline;
        default:
            return '';
    }
}

function shouldSkipAggLandingPageSPM(modelVM) {
    function isModelValid() {
        return (!SpmUtils.isVehicleLeased(modelVM)
            && !SpmUtils.claimsRequireCustomerInput(modelVM)
            && !SpmUtils.hasSpecifiedModifications(modelVM))
            && modelVM.baseData.motorAccountHolder.emailAddress1.aspects.valid
            && modelVM.baseData.motorAccountHolder.primaryAddress.addressLine1.aspects.valid
            && modelVM.baseData.motorAccountHolder.primaryAddress.addressLine3.aspects.valid
            && modelVM.baseData.motorAccountHolder.maritalStatus.aspects.valid;
    }

    function skipAggregatorLandingPage() {
        if ((modelVM.value.aggregatorDetailsDTO_Ext
            && modelVM.value.aggregatorDetailsDTO_Ext.aggLandingVisited_Ext !== undefined)) {
            if (modelVM.value.aggregatorDetailsDTO_Ext.aggLandingVisited_Ext === true) {
                return true;
            }
        }
        return isModelValid();
    }
    return skipAggregatorLandingPage();
}

function shouldSkipAggLandingPageSPH(modelVM) {
    function isHomeTailormadeQuoteWithContents() {
        try {
            return SphUtils.isHomeTailormade(modelVM) && SphUtils.hasContentsCover(modelVM);
        } catch (e) {
            return false;
        }
    }

    const isRebuildCostRequired = () => {
        return modelVM.lobData.privateHome.coverables.propertyDetails.rebuildCost.amount
                && modelVM.lobData.privateHome.coverables.propertyDetails.rebuildCost.amount.value !== undefined
            && modelVM.lobData.privateHome.coverables.propertyDetails.rebuildCost.amount.value < SphConstants.UNDER_REBUILD_AMOUNT;
    };

    function isModelValid() {
        return !modelVM.lobData.privateHome.coverables.propertyDetails.propertyOccupants.aspects.required
            && !modelVM.lobData.privateHome.coverables.morePropertyDetails.hasBusinessUse.value
            && !modelVM.lobData.privateHome.coverables.otherInfoAboutYou.claims.value.length > 0
            && !isHomeTailormadeQuoteWithContents()
            && modelVM.baseData.homeAccountHolder.emailAddress1.aspects.valid
            && !isRebuildCostRequired();
    }
    function skipAggregatorLandingPage() {
        if ((modelVM.value.aggregatorDetailsDTO_Ext
            && modelVM.value.aggregatorDetailsDTO_Ext.aggLandingVisited_Ext !== undefined)) {
            if (modelVM.value.aggregatorDetailsDTO_Ext.aggLandingVisited_Ext === true) {
                return true;
            }
        }
        return isModelValid();
    }
    return skipAggregatorLandingPage();
}

function shouldSkipAggLandingPage(modelVM) {
    if (modelVM.value.aggregatorDetailsDTO_Ext && modelVM.value.aggregatorDetailsDTO_Ext.isAggregatorQuote_Ext) {
        const { isHome, isMotor } = appConfig;
        if (isHome) {
            return shouldSkipAggLandingPageSPH(modelVM);
        }
        if (isMotor) {
            return shouldSkipAggLandingPageSPM(modelVM);
        }
    }
    return true;
}

function getQuotePageStepIndex() {
    const { isSmi } = appConfig;
    if (isSmi) {
        return 1;
    }
    return 2;
}

function getBreadcrubmsSteps() {
    const { isHome, isTravel, isSmi } = appConfig;
    if (isHome) {
        return [
            messages.PropertyStep,
            messages.DetailsStep,
            messages.QuoteStep,
            messages.PaymentStep,
            messages.ConfirmationStep
        ];
    }
    if (isTravel) {
        return [
            messages.TravelDetails,
            messages.TravelMedical,
            messages.QuoteStep,
            messages.PaymentStep,
            messages.ConfirmationStep
        ];
    }
    if (isSmi) {
        return [
            messages.SmiAboutYou,
            messages.QuoteStep,
            messages.SmiReview,
            messages.PaymentStep,
            messages.ConfirmationStep
        ];
    }
    return [
        messages.CarStep,
        messages.DriversStep,
        messages.QuoteStep,
        messages.PaymentStep,
        messages.ConfirmationStep
    ];
}

function getCarouselArticles() {
    const {
        isHome,
        isMotor,
        isTravel,
        isSmi
    } = appConfig;
    if (isHome) {
        return [
            {
                url: CommonConstants.SAGA_ARTICLES_URLS.REDUCE_ENERGY_BILLS,
                name: messages.ReduceEnergyBillsName,
                text: {
                    header: messages.ReduceEnergyBillsHeader,
                    description: messages.ReduceEnergyBillsDescription
                }
            },
            {
                url: CommonConstants.SAGA_ARTICLES_URLS.WORKING_FROM_HOME,
                name: messages.WorkingFromHomeName,
                text: {
                    header: messages.WorkingFromHomeHeader,
                    description: messages.WorkingFromHomeDescription
                }
            },
            {
                url: CommonConstants.SAGA_ARTICLES_URLS.GARAGE_INSURANCE,
                name: messages.GarageInsuranceName,
                text: {
                    header: messages.GarageInsuranceHeader,
                    description: messages.GarageInsuranceDescription
                }
            },
            {
                url: CommonConstants.SAGA_ARTICLES_URLS.NEW_BOILER_COST,
                name: messages.NewBoilerCostName,
                text: {
                    header: messages.NewBoilerCostHeader,
                    description: messages.NewBoilerCostDescription
                }
            },
            {
                url: CommonConstants.SAGA_ARTICLES_URLS.ENGAGEMENT_RING_INSURANCE,
                name: messages.EngagementRingInsuranceName,
                text: {
                    header: messages.EngagementRingInsuranceHeader,
                    description: messages.EngagementRingInsuranceDescription
                }
            }
        ];
    }
    if (isMotor) {
        return [
            {
                url: CommonConstants.SAGA_ARTICLES_URLS.CAR_BREAK_DOWN,
                name: messages.CarBreakDownName,
                text: {
                    header: messages.CarBreakDownHeader,
                    description: messages.CarBreakDownDescription
                }
            },
            {
                url: CommonConstants.SAGA_ARTICLES_URLS.KEYLESS_CAR_THEFT,
                name: messages.KeylessCarTheftName,
                text: {
                    header: messages.KeylessCarTheftHeader,
                    description: messages.KeylessCarTheftDescription
                }
            },
            {
                url: CommonConstants.SAGA_ARTICLES_URLS.CHILD_CAR_SEAT,
                name: messages.ChildCarSeatName,
                text: {
                    header: messages.ChildCarSeatHeader,
                    description: messages.ChildCarSeatDescription
                }
            },
            {
                url: CommonConstants.SAGA_ARTICLES_URLS.DRIVING_ABROAD,
                name: messages.DrivingAbroadName,
                text: {
                    header: messages.DrivingAbroadHeader,
                    description: messages.DrivingAbroadDescription
                }
            },
            {
                url: CommonConstants.SAGA_ARTICLES_URLS.PENALTY_POINTS,
                name: messages.PenaltyPointsName,
                text: {
                    header: messages.PenaltyPointsHeader,
                    description: messages.PenaltyPointsDescription
                }
            }
        ];
    }
    if (isTravel) {
        return [
            {
                url: CommonConstants.SAGA_ARTICLES_URLS.HOLIDAY_CHECKLIST,
                name: messages.HolidayChecklistName,
                text: {
                    header: messages.HolidayChecklistHeader,
                    description: messages.HolidayChecklistDescription
                }
            },
            {
                url: CommonConstants.SAGA_ARTICLES_URLS.CANCELLED_FLIGHTS,
                name: messages.CancelledFlightsName,
                text: {
                    header: messages.CancelledFlightsHeader,
                    description: messages.CancelledFlightsDescription
                }
            },
            {
                url: CommonConstants.SAGA_ARTICLES_URLS.TRAVEL_GP,
                name: messages.TravelGPName,
                text: {
                    header: messages.TravelGPHeader,
                    description: messages.TravelGPDescription
                }
            },
            {
                url: CommonConstants.SAGA_ARTICLES_URLS.DELAYED_FLIGHT,
                name: messages.DelayedFlightName,
                text: {
                    header: messages.DelayedFlightHeader,
                    description: messages.DelayedFlightDescription
                }
            },
            {
                url: CommonConstants.SAGA_ARTICLES_URLS.TRAVEL_PROTECT,
                name: messages.TravelProtectName,
                text: {
                    header: messages.TravelProtectHeader,
                    description: messages.TravelProtectDescription
                }
            }
        ];
    }
    if (isSmi) {
        return [
            {
                url: CommonConstants.SAGA_ARTICLES_URLS.BOOST_YOUR_IMMUNE_SYSTEM,
                name: messages.BoostYourSystemName,
                text: {
                    header: messages.BoostYourSystemHeader,
                    description: messages.BoostYourSystemDescription
                }
            },
            {
                url: CommonConstants.SAGA_ARTICLES_URLS.PRE_EXISTING_CONDITIONS,
                name: messages.PreExistingConditionsName,
                text: {
                    header: messages.PreExistingConditionsHeader,
                    description: messages.PreExistingConditionsDescription
                }
            },
            {
                url: CommonConstants.SAGA_ARTICLES_URLS.OPTIONS_TO_IMPROVE_COVER,
                name: messages.OptionsCoverName,
                text: {
                    header: messages.OptionsCoverHeader,
                    description: messages.OptionsCoverDescription
                }
            },
            {
                url: CommonConstants.SAGA_ARTICLES_URLS.YOUR_CHOICE_OF_HOSPITAL,
                name: messages.HospitalChoiceName,
                text: {
                    header: messages.HospitalChoiceHeader,
                    description: messages.HospitalChoiceDescription
                }
            },
            {
                url: CommonConstants.SAGA_ARTICLES_URLS.SELF_EMPLOYED,
                name: messages.SelfEmployedName,
                text: {
                    header: messages.SelfEmployedHeader,
                    description: messages.SelfEmployedDescription
                }
            }
        ];
    }
    return [];
}

function getCoverTypeMessage(modelVM) {
    const { isTravel } = appConfig;
    if (isTravel) {
        return SgSptTripUtils.isSelectedTripSingle(modelVM) ? messages.SingleTrip : messages.AnnualTrip;
    }
    return '';
}

function getCoverLevel(modelVM) {
    const {
        isHome,
        isMotor,
        isTravel,
        isSmi
    } = appConfig;
    if (isHome) {
        return CommonConstants.HOME_COVER_TYPES[modelVM.lobData.privateHome.coverables.coverLevel.value.code.toUpperCase()];
    }
    if (isMotor) {
        const vehicle = modelVM.lobData.privateMotor.coverables.spmVehicle.value;
        let coverLevelName;
        if (vehicle.coverLevel === SpmConstants.COVER_LEVEL_CODES.SAGA_STANDARD) {
            coverLevelName = SpmConstants.SG_COVER_LEVELS.MOTOR_STANDARD;
        }
        if (vehicle.coverLevel === SpmConstants.COVER_LEVEL_CODES.SAGA_SELECT) {
            coverLevelName = SpmConstants.SG_COVER_LEVELS.MOTOR_COMPREHENSIVE;
        }
        if (vehicle.coverLevel === SpmConstants.COVER_LEVEL_CODES.SAGA_PLUS) {
            coverLevelName = SpmConstants.SG_COVER_LEVELS.MOTOR_FIXED_PRICE;
        }
        return coverLevelName;
    }
    if (isTravel) {
        switch (SgSptTripUtils.getSelectedTrip(modelVM).coverLevel) {
            case SgSptConstants.COVER_LEVELS.STANDARD:
                return CommonConstants.COVER_LEVEL_NAMES.STANDARD;
            case SgSptConstants.COVER_LEVELS.SELECT:
                return CommonConstants.COVER_LEVEL_NAMES.SELECT;
            case SgSptConstants.COVER_LEVELS.PLUS:
                return CommonConstants.COVER_LEVEL_NAMES.PLUS;
            case SgSptConstants.COVER_LEVELS.ESSENTIAL:
                return CommonConstants.COVER_LEVEL_NAMES.ESSENTIAL;
            default:
                break;
        }
    }
    if (isSmi) {
        let selectedPlanLevel;
        switch (modelVM.lobData.privateMedical.coverables.smiInsurance.selectedCoverLevel.value.code) {
            case SmiConstants.COVER_LEVEL_CODES.SAVER_PLUS:
                selectedPlanLevel = SmiConstants.PRODUCT_TYPE.SAVER_PLUS;
                break;
            case SmiConstants.COVER_LEVEL_CODES.SECURE:
                selectedPlanLevel = SmiConstants.PRODUCT_TYPE.SECURE;
                break;
            case SmiConstants.COVER_LEVEL_CODES.SUPER:
                selectedPlanLevel = SmiConstants.PRODUCT_TYPE.SUPER;
                break;
            default:
                selectedPlanLevel = '';
        }
        return selectedPlanLevel;
    }
    return '';
}

function getTravelTripDestinations(trip, isSingleTrip, translator) {
    const getDestinations = () => {
        const destinations = trip.sptTripDestinations
            .map((item) => translator({
                id: `typekey.SPTDestination.${item.destination}`,
                defaultMessage: ''
            }));
        if (destinations.length > 3) {
            return translator(messages.DestinationSeeACompleteList, {
                destinationsAfterJoin: destinations.slice(0, 3).join(', '),
                hiddenCountriesCount: destinations.length - 3
            });
        }
        return destinations.join(', ');
    };

    const getRegion = () => {
        if (trip.region === SgSptConstants.REGIONS.WORLDWIDE_INCL) {
            return translator(messages.RegionWorldIncl);
        }
        if (trip.region === SgSptConstants.REGIONS.WORLDWIDE_EXCL) {
            return translator(messages.RegionWorldExcl);
        }
        return translator(messages.RegionEurope);
    };

    if (!isSingleTrip) {
        return getRegion();
    }
    if (isSingleTrip) {
        return getDestinations();
    }
    return '';
}

function getPolicyDates(modelVM) {
    const { isTravel } = appConfig;
    if (isTravel) {
        const trip = SgSptTripUtils.getSelectedTrip(modelVM);
        return {
            periodStartDate: modelVM.baseData.periodStartDate.value,
            periodEndDate: SgSptTripUtils.isSelectedTripSingle(modelVM) ? trip.returnDate
                : SgDateUtil.addDaysToDateDTO(-1, modelVM.baseData.periodEndDate.value)
        };
    }
    return {
        periodStartDate: modelVM.baseData.periodStartDate.value,
        periodEndDate: SgDateUtil.addDaysToDateDTO(-1, modelVM.baseData.periodEndDate.value)
    };
}

function getProductSummaryInfoMessage(modelVM) {
    const {
        isHome, isMotor, isTravel, isSmi
    } = appConfig;
    if (isHome) {
        return messages.AddressInfo;
    }
    if (isMotor) {
        return messages.VehicleInfo;
    }
    if (isTravel) {
        return messages.DestinationInfo;
    }
    if (isSmi) {
        return SgSubmissionUtil.getAccountHolder(modelVM).displayName.value;
    }
    return '';
}

function getProductSummaryInfoParameters(modelVM, translator) {
    const { isHome, isMotor, isTravel } = appConfig;
    if (isHome) {
        const address = modelVM.lobData.privateHome.coverables.propertyDetails.location.policyLocation.value;
        const countyDetail = address.county ? `${address.county},` : '';
        return {
            addressLine1: address.addressLine1,
            addressLine2: address.addressLine2,
            addressLine3: address.addressLine3,
            city: address.city,
            county: countyDetail,
            postalCode: address.postalCode
        };
    }
    if (isMotor) {
        const vehicle = modelVM.lobData.privateMotor.coverables.spmVehicle.value;
        return {
            make: vehicle.make,
            model: vehicle.model,
            registrationNumber: vehicle.registrationNumber
        };
    }
    if (isTravel) {
        return {
            destination: getTravelTripDestinations(SgSptTripUtils.getSelectedTrip(modelVM), SgSptTripUtils.isSelectedTripSingle(modelVM), translator)
        };
    }
    return {};
}

function shouldShowConfirmationPaymentMethod() {
    const { isHome, isMotor, isSmi } = appConfig;
    if (isHome || isMotor || isSmi) {
        return true;
    }
    return false;
}
function shouldShowConfirmationPlanType() {
    const { isSmi } = appConfig;
    return isSmi;
}
function showDocumentsPostalDefaultMessage() {
    const { isSmi } = appConfig;
    return !isSmi;
}

function isCpaAvailable(modelVM) {
    const { isTravel } = appConfig;
    if (isTravel) {
        return !SgSptTripUtils.isSelectedTripSingle(modelVM);
    }
    return true;
}

function isQuickQuoteBannerAvailable() {
    const { isHome, isMotor } = appConfig;
    return isHome || isMotor;
}

function getQuickQuoteBannerSubHeader(hasHomePoliciesAtSameAddress) {
    const { isHome, isMotor } = appConfig;
    if (isHome) {
        return messages.QuickQuoteSubHeaderHome;
    }
    if (isMotor) {
        return hasHomePoliciesAtSameAddress ? messages.QuickQuoteSubHeaderMotorWithoutHome : messages.QuickQuoteSubHeaderMotor;
    }
    return '';
}

function getProductsToHideInSagaOtherProducts() {
    const {
        isHome, isMotor, isTravel, isSmi
    } = appConfig;
    const isCar = SgProductService.isCar();
    return {
        hideMotor: isMotor || isHome,
        hideHome: isCar || isHome,
        hideSmi: isSmi,
        hideTravel: isTravel
    };
}

function tagOnPaymentPageEntry(modelVM) {
    const { isTravel } = appConfig;
    if (isTravel) {
        publish(ADOBE_TOPICS.ADOBE_EVENT, {
            adobeID: SPTTaggingProperties.quoteStep,
            value: SgSubmissionUtil.isAggregatorQuote(modelVM)
                ? SgSptConstants.ADOBE_QUOTE_STEPS_AGGS.PAYMENT_STEP : SgSptConstants.ADOBE_QUOTE_STEPS.PAYMENT_STEP
        });
    }
}

function setAutoRenewal(modelVM) {
    const { isTravel } = appConfig;
    if (isTravel) {
        return SgSptTripUtils.isSelectedTripAnnual(modelVM);
    }
    return true;
}

function setCookiesOnRetrieval(submission) {
    const { isSmi } = appConfig;
    if (isSmi) {
        SgSmiCookieUtils.setCookiesOnRetrieval(submission);
    }
}

function callDiallerOnPaymentPage(modelVM) {
    const { isSmi } = appConfig;
    if (isSmi && !_.isNil(modelVM.baseData.smiAccountHolder.homeNumber.value)) {
        const phoneNumber = modelVM.baseData.smiAccountHolder.homeNumber.value;
        SgSmiUtils.callDialler(modelVM, SmiConstants.DIALLER_JOURNEY_INDEX.PAYMENT_PAGE_INIT, phoneNumber);
    }
}
function showAgeasWording() {
    const { isHome, isMotor } = appConfig;
    if ((isMotor && !SgProductService.isMotorHome()) || isHome) {
        return appConfig.showAgeasWording;
    }
    return false;
}

function getCpcJourneyString(modelVM) {
    const isAggregatorQuote = SgSubmissionUtil.isAggregatorQuote(modelVM);
    let journeyString = '';
    const { isHome, isMotor } = appConfig;
    if (isHome) {
        if (isAggregatorQuote) {
            journeyString = showAgeasWording() ? CommonConstants.CUSTOMER_PERMISSION_SECTION.HOME_AGEAS_AGG_JOURNEY
                : CommonConstants.CUSTOMER_PERMISSION_SECTION.HOME_AGG_JOURNEY;
        } else {
            journeyString = showAgeasWording() ? CommonConstants.CUSTOMER_PERMISSION_SECTION.HOME_AGEAS_JOURNEY
                : CommonConstants.CUSTOMER_PERMISSION_SECTION.HOME_JOURNEY;
        }
    }
    if (isMotor) {
        if (isAggregatorQuote) {
            journeyString = showAgeasWording() ? CommonConstants.CUSTOMER_PERMISSION_SECTION.MOTOR_AGEAS_AGG_JOURNEY
                : CommonConstants.CUSTOMER_PERMISSION_SECTION.MOTOR_AGG_JOURNEY;
        } else {
            journeyString = showAgeasWording() ? CommonConstants.CUSTOMER_PERMISSION_SECTION.MOTOR_AGEAS_JOURNEY
                : CommonConstants.CUSTOMER_PERMISSION_SECTION.MOTOR_JOURNEY;
        }
    }
    return journeyString;
}

function getCpcProductPhoneNumber() {
    const { isHome, isMotor } = appConfig;
    let phoneNumber;
    if (isMotor) {
        phoneNumber = CommonConstants.SAGA_PHONE_NUMBERS.SAGA_HELP_DESK_MOTOR_PHONE_NUMBER1;
    }
    if (isHome) {
        phoneNumber = CommonConstants.SAGA_PHONE_NUMBERS.SAGA_ERROR_HOME_PHONE_NUMBER;
    }
    return phoneNumber;
}

function getCpcProductType() {
    const { isHome, isMotor } = appConfig;
    let product;
    if (isMotor) {
        product = CommonConstants.CUSTOMER_PERMISSION_SECTION.MOTOR_PRODUCT;
    }
    if (isHome) {
        product = CommonConstants.CUSTOMER_PERMISSION_SECTION.HOME_PRODUCT;
    }
    return product;
}

function getRetrievalPageCustomErrorMessageContent(customError, translator) {
    const landlordRetrieval = SphConstants.LANDLORD_PRODUCT_CODE;
    return customError.includes(landlordRetrieval)
        ? htmlParser(sanitizeHtml(translator(messages.RetrievalPageLandlordErrorMessage)))
        : translator(messages.RetrievalPageTailormadeErrorMessage, {
            phoneNumber: SphConstants.HISCOX_TAILOR_MADE_PHONE_NUMBER
        });
}

function getCpcSourceSystem(modelVM) {
    const {
        isHome, isMotor, isTravel, isSmi
    } = appConfig;
    if (isMotor) {
        if (SgSubmissionUtil.isAggregatorQuote(modelVM)) {
            return CommonConstants.CUSTOMER_PERMISSION_SECTION.SOURCE.MOTOR_AGGREGATOR;
        }
        return CommonConstants.CUSTOMER_PERMISSION_SECTION.SOURCE.MOTOR_JOURNEY;
    }
    if (isHome) {
        if (SgSubmissionUtil.isAggregatorQuote(modelVM)) {
            return CommonConstants.CUSTOMER_PERMISSION_SECTION.SOURCE.HOME_AGGREGATOR;
        }
        return CommonConstants.CUSTOMER_PERMISSION_SECTION.SOURCE.HOME_JOURNEY;
    }
    if (isTravel) {
        if (SgSubmissionUtil.isAggregatorQuote(modelVM)) {
            return CommonConstants.CUSTOMER_PERMISSION_SECTION.SOURCE.TRAVEL_AGGREGAROR;
        }
        return CommonConstants.CUSTOMER_PERMISSION_SECTION.SOURCE.TRAVEL_JOURNEY;
    }
    if (isSmi) {
        return CommonConstants.CUSTOMER_PERMISSION_SECTION.SOURCE.PMI_JOURNEY;
    }
    return CommonConstants.CUSTOMER_PERMISSION_SECTION.SOURCE.GENERAL;
}

function getFaqMessageParams(translator, isMobile) {
    const {
        isMotor, isTravel, isSmi
    } = appConfig;
    if (isMotor) {
        const healthConditionText = translator(messages.HealthConditionText);
        const medicalConditionText = translator(messages.MedicalConditionText);
        const countriesCoveredText = translator(messages.CountriesCoveredText);
        const drivingEuropeText = translator(messages.DrivingEuropeText);
        const otherVehiclesText = translator(messages.OtherVehiclesText);
        return {
            healthConditionLink: `<a target="_blank" href=${sanitizeUrl(SpmConstants.FAQ_LINKS.HEALTH_LINK)}>${healthConditionText}</a>`,
            medicalConditionLink: `<a target="_blank" href=${sanitizeUrl(SpmConstants.FAQ_LINKS.MEDICAL_LINK)}>${medicalConditionText}</a>`,
            countriesCoveredLink: `<a target="_blank" href=${sanitizeUrl(SpmConstants.FAQ_LINKS.COUNTRIES_COVERED_LINK)}>${countriesCoveredText}</a>`,
            drivingInEuropeLink: `<a target="_blank" href=${sanitizeUrl(SpmConstants.FAQ_LINKS.DRIVING_LINK)}>${drivingEuropeText}</a>`,
            otherVehiclesLink: `<a target="_blank" href=${sanitizeUrl(CommonConstants.MY_SAGA_LINK)}>${otherVehiclesText}</a>`
        };
    }
    if (isTravel) {
        const fcdoAdviceText = translator(messages.FcdoAdviceText);
        return {
            fcdoAdviceLink: `<a target="_blank" href=${sanitizeUrl(SgSptConstants.ESSENTIAL_REASONS_LINK)}>${fcdoAdviceText}</a>`
        };
    }
    if (isSmi) {
        const healthPlanText = translator(messages.HealthPlanText);
        const abiGuideText = translator(messages.ABIGuideText);
        const policyBooksText = translator(messages.PolicyBooksText);
        const phoneNumber = CommonConstants.SAGA_PHONE_NUMBERS.SAGA_SMI_PHONE_NUMBER;
        return {
            healthPlanLink: `<a target="_blank" href=${sanitizeUrl(SmiConstants.SAGA_HEALTHPLAN_LINK)}>${healthPlanText}</a>`,
            abiGuideLink: `<a target="_blank" href=${sanitizeUrl(SmiConstants.ABI_GUIDE_LINK)}>${abiGuideText}</a>`,
            policyBooksLink: `<a target="_blank" href=${sanitizeUrl(SmiConstants.POLICY_BOOKS_LINK)}>${policyBooksText}</a>`,
            phoneNumber: isMobile
                ? (
                    `&lt;a href="tel:${phoneNumber.replaceAll(' ', '')}"&gt;${phoneNumber}&lt;/a&gt;`
                ) : `<b>${phoneNumber}</b>`
        };
    }
    return {};
}

function getOpenLines() {
    const {
        isMotor, isTravel, isSmi, isHome
    } = appConfig;
    if (isMotor || isHome) {
        return {
            timeWeekDays: messages.TimeWeekDaysHomeMotor,
            timeSaturday: messages.TimeSaturdayHomeMotor,
            timeSunday: messages.TimeSundayHomeMotor
        };
    }
    if (isTravel) {
        return {
            timeWeekDays: messages.TimeWeekDaysTravel,
            timeSaturday: messages.TimeSaturdayTravel,
            timeSunday: messages.TimeSundayTravel
        };
    }
    if (isSmi) {
        return {
            timeWeekDays: messages.TimeWeekDaysSmi,
            timeSaturday: messages.TimeSaturdaySmi,
            timeSunday: messages.TimeSundaySmi
        };
    }
    return {};
}

function getWebChatOpenTime() {
    const {
        isTravel, isSmi
    } = appConfig;
    return {
        startTime: moment('8:30:00', 'hh:mm:ss'),
        endTime: isSmi || isTravel ? moment('19:00:00', 'hh:mm:ss') : moment('20:00:00', 'hh:mm:ss'),
        saturdayEndTime: isSmi ? moment('13:00:00', 'hh:mm:ss') : moment('17:00:00', 'hh:mm:ss')
    };
}

function getYourCreditExplainedPhoneNumber() {
    const { isHome, isMotor } = appConfig;
    let phoneNumber;
    if (isMotor) {
        phoneNumber = CommonConstants.SAGA_PHONE_NUMBERS.SAGA_IPID_OTHER_PHONE_NUMBER;
    }
    if (isHome) {
        phoneNumber = CommonConstants.SAGA_PHONE_NUMBERS.SAGA_HOME_YOUR_CREDIT_EXPLAINED_PHONE_NUMBER;
    }
    return phoneNumber;
}

function showDefaqtoBannerOnRetrievalPage() {
    const { isTravel, isSmi } = appConfig;
    const isMotorHome = SgProductService.isMotorHome();
    if (isTravel || isSmi || isMotorHome) {
        return false;
    }
    return true;
}

function getGdprPhoneNumber() {
    const { isSmi } = appConfig;
    return isSmi ? CommonConstants.SAGA_PHONE_NUMBERS.SAGA_SMI_HELP_DESK_GDPR_PHONE_NUMBER
        : CommonConstants.SAGA_PHONE_NUMBERS.SAGA_HELP_DESK_GDPR_PHONE_NUMBER;
}

export default {
    showDocumentsPostalDefaultMessage,
    isCpaAvailable,
    isQuickQuoteBannerAvailable,
    getQuickQuoteBannerSubHeader,
    getPaymentsHeaderMessage,
    getPaymentsHeaderMessageParameters,
    shouldSkipAggLandingPage,
    getSupportBannerMessage,
    getBreadcrubmsSteps,
    getRetrievalPageErrorReasonMessage,
    getCarouselArticles,
    getCoverTypeMessage,
    getCoverLevel,
    getPolicyDates,
    getProductSummaryInfoMessage,
    getProductSummaryInfoParameters,
    shouldShowConfirmationPaymentMethod,
    shouldShowConfirmationPlanType,
    tagOnPaymentPageEntry,
    setAutoRenewal,
    setCookiesOnRetrieval,
    callDiallerOnPaymentPage,
    getQuotePageStepIndex,
    getCpcJourneyString,
    getCpcProductPhoneNumber,
    getCpcProductType,
    getRetrievalPageCustomErrorMessageContent,
    getCpcSourceSystem,
    getFaqMessageParams,
    getOpenLines,
    getWebChatOpenTime,
    getYourCreditExplainedPhoneNumber,
    showDefaqtoBannerOnRetrievalPage,
    getGdprPhoneNumber,
    getProductsToHideInSagaOtherProducts,
    showAgeasWording
};
